export const todaySubject = {
  title: "ChatGPT 프롬프트 엔지니어링 기초",
  instructor: "김지훈 강사",
  instructorAvatar: "https://public.readdy.ai/ai/img_res/939038709eff05e0964bb937ae1d702a.jpg",
  week: 3,
  lesson: 7,
};

export const tasks321 = [
  {
    id: 1,
    number: 1,
    title: "기본 프롬프트 5가지 작성하기",
    desc: "ChatGPT에게 명령할 때 사용하는 기본 프롬프트 패턴 5가지를 직접 작성하고 결과를 캡처하세요.",
    estimatedTime: "40분",
    icon: "ri-quill-pen-line",
    category: "실습",
    status: "todo",
    aiScore: null as number | null,
    expertApproved: false,
    hint: "역할 부여(Role), 형식 지정(Format), 예시 포함(Few-shot) 패턴을 활용해 보세요.",
  },
  {
    id: 2,
    number: 2,
    title: "고급 프롬프트 체인 실습",
    desc: "복잡한 업무를 단계별로 분리하여 AI와 대화를 이어가는 '프롬프트 체인' 기법을 실습하세요.",
    estimatedTime: "50분",
    icon: "ri-link-m",
    category: "심화",
    status: "todo",
    aiScore: null as number | null,
    expertApproved: false,
    hint: "이전 대화 결과를 다음 프롬프트의 입력값으로 사용해 보세요.",
  },
  {
    id: 3,
    number: 3,
    title: "나만의 AI 어시스턴트 설계",
    desc: "학습한 프롬프트 기법을 활용해 특정 업무(이력서 작성, 보고서 요약 등)를 자동화하는 AI 어시스턴트를 설계하세요.",
    estimatedTime: "30분",
    icon: "ri-robot-2-line",
    category: "창작",
    status: "todo",
    aiScore: null as number | null,
    expertApproved: false,
    hint: "사용자가 입력만 하면 바로 결과가 나오도록 시스템 프롬프트를 완성해 보세요.",
  },
];

export const weeklyProgress = [
  { week: 1, title: "AI 리터러시 기초", completed: true, score: 92 },
  { week: 2, title: "ChatGPT 활용법", completed: true, score: 88 },
  { week: 3, title: "프롬프트 엔지니어링", completed: false, score: null },
  { week: 4, title: "이미지 AI 활용", completed: false, score: null },
  { week: 5, title: "AI 비즈니스 적용", completed: false, score: null },
];

export const aiFeedbackExamples = [
  "훌륭한 프롬프트입니다! 역할 부여와 형식 지정을 잘 활용했어요. '출력 언어: 한국어'를 추가하면 더 일관된 결과를 얻을 수 있어요.",
  "프롬프트 체인 구성이 논리적이에요! 각 단계의 연결이 자연스럽습니다. 3단계에서 '이전 단계 요약본을 포함하여'라는 문구를 추가해 보세요.",
  "창의적인 AI 어시스턴트 설계네요! 시스템 프롬프트의 경계 조건(edge case)을 더 정의하면 훨씬 안정적으로 동작할 거예요.",
];
